import React, { useEffect, useRef, useState } from "react";
import MenuIcon from "../../../images/horizontal-icon.svg";
import DBSIcon from "../../../images/dbs.svg";
import FeaturedIcon from "../../../images/featured.svg";
import EditIcon from "../../../images/edit.svg";
import DeleteIcon from "../../../images/delete.svg";
import InactiveIcon from "../../../images/inactive.svg";
import TimeIcon from "../../../images/time.svg";
import LTVIcon from "../../../images/ltv.svg";
import { useSelector } from "react-redux";
import { getNameFromSettings, getTime } from "../../../helpers/utils";
import {
  LOAN_PROVIDER_IMAGE_BASE_URL,
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LOAN_PROVIDERS_LIST,
  SETTINGS_LTV_LIST,
  SETTINGS_PRODUCT_TYPE_LIST,
} from "../../../helpers/constants";
import MoreIcon from "../../../images/more-horizontal.png";
import { FaCrown } from "react-icons/fa";
import { AiFillStar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  MenuItem,
  ThemeProvider,
  alpha,
  createTheme,
  styled,
} from "@mui/material";
import { useCallback } from "react";
import LoginIcon from "../../../images/login.svg";
import Noimage from "../../../images/noimage.png";

export default function CustomerGridItem(props) {
  const {
    data,
    onDeleteClick,
    handleCloseMenu,
    handleOpenMenu,
    handleLogin,
    menuOpen,
    anchorEl,
    index,
    pagePermission,
  } = props;
  const settings = useSelector((state) => state.settings);
  const navigate = useNavigate();

  const onDelete = useCallback(() => {
    onDeleteClick(data.id);
    handleCloseMenu();
  }, [data, onDeleteClick, handleCloseMenu]);

  //console.log("data", data);

  return (
    <ThemeProvider theme={createTheme()}>
      <div
        id={data.id}
        className="rounded-[16px] bg-white  p-[16px_20px] w-[32%] max-[1300px]:w-[48%] max-[1200px]:w-[48%] max-[700px]:w-[100%] max-w-[100%] cus_shadow2 relative z-0"
      >
        <div className="card_head relative flex justify-between items-center mb-[10px]">
          <div className="absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]">
            {/* <img
              src={`${LOAN_PROVIDER_IMAGE_BASE_URL}/${data.avatar}`}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ maxWidth: "100%", height: "auto" }}
            /> */}
            <img
              src={
                data?.avatar
                  ? `${LOAN_PROVIDER_IMAGE_BASE_URL}/${data.avatar}`
                  : Noimage // ✅ Use fallback image if no avatar
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage; // ✅ Set fallback image on error
              }}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ width: "auto", height: "40px", margin: "10px auto" }}
            />
          </div>
          <span className="pl-[70px] flex-fixed font-[700] line-clamp-1">
            {data.name}
          </span>
          <div
            className="w-[46%]"
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <p className="text-[11px] text-gray-500">Registered via:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] capitalize tracking-[-.15px]">
              {"Ohhto"}
            </p>
          </div>
          {pagePermission?.update_permission == 1 && (
            <div className="py-1 px-2 gap-2">
              <img
                src={MoreIcon}
                className="w-5 cursor-pointer"
                onClick={(e) => handleOpenMenu(index, e)}
                id="fade-button"
              />
              <div className="menu-container ">
                <Menu
                  id="fade-button"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                  }}
                  anchorEl={anchorEl}
                  open={menuOpen}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                      mt: 1,
                      minWidth: "140px",
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem
                    onClick={() => navigate(`/accounts/customers/${data.id}`)}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <img src={EditIcon} className="h-4 w-4 mr-4" />
                    View Customer
                  </MenuItem>
                  {pagePermission.delete_permission == 1 && (
                    <MenuItem
                      onClick={onDelete}
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: '"Inter", sans-serif',
                      }}
                    >
                      <img src={DeleteIcon} className="h-4 w-4 mr-4" />
                      Delete
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => handleLogin(data.id)}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <img src={LoginIcon} className="h-4 w-4 mr-4" />
                    Login
                  </MenuItem>

                </Menu>
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between flex-wrap gap-[10px]">
          <div className="w-[46%]">
            <p className="text-[11px] text-gray-500">ID:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] tracking-[-.15px]">
              {data.unique_id}
            </p>
          </div>
          <div className="w-[46%]">
            <p className="text-[11px] text-gray-500">
              {data.status == 1
                ? "Approved"
                : data.status == 2
                  ? "Rejected"
                  : data.status == 3
                    ? "Banned"
                    : ""}{" "}
              joined Date:
            </p>
            <p className="text-[13px] md:text-xs text-black font-[600] capitalize tracking-[-.15px]">
              {data.status == 0 || data.status == 1
                ? getTime(data.approved_at)
                : data.status == 1
                  ? getTime(data.rejected_at)
                  : data.status == 2
                    ? getTime(data.banned_at)
                    : ""}
            </p>
          </div>
          <div className="w-[46%]">
            <p className="text-[11px] text-gray-500">Contact:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] capitalize tracking-[-.15px]">
              {data.phone_number}
            </p>
          </div>
          <div className="w-[46%]">
            <p className="text-[11px] text-gray-500">Email:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] tracking-[-.15px]">
              {data.email}
            </p>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
